/* eslint-disable import/first */
import React, { useState, useContext, useEffect } from 'react';
import { useNavigate, useLocation } from '@reach/router';
import { Grid, Paper, Button } from '@material-ui/core';
import { Redux, Slices } from 'spwa-ui-library';
import { useIntl, FormattedMessage } from 'react-intl';
import { Context } from '../../components/Multi-lang/Wrapper';
import SocialMedia from './SocialMedia';
import LoginForm from './LoginForm';
import Footer from './Footer';
import SeoTitle from '../../components/SeoTitle';
import Hreflang from '../../components/Hreflang';
import banner from './images/banner.png';
import bannerAr from './images/banner_ar.png';
import bannerSmall from './images/banner_small.png';
import bannerSmallAr from './images/banner_small_ar.png';
import {
  loginAttemptGA,
  requestOtpMobileGA,
  otpResponseMobileGA,
} from 'spwa-ui-library/esm/utils/helperGA';
import css from './index.module.scss';
import classNames from 'classnames';
const { useSelector, useDispatch } = Redux;
const { selectDesktop } = Slices.appSlice;
const { sendOtp, selectLoginStatus, logout } = Slices.authSlice;
const { selectCountryValidations } = Slices.configSlice;

function Login({ path, locale }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { state } = location || {};
  const intl = useIntl();
  const [phnNo, setPhnNo] = useState(state?.phnNo || '');
  const [status, setStatus] = useState('initial');
  const isDesktop = useSelector(selectDesktop);
  const context = useContext(Context);
  const config = useSelector((state) => state.config);
  const profile = useSelector((state) => state.profile);
  const auth = useSelector((state) => state.auth);
  const isLoggedIn = useSelector(selectLoginStatus);
  const [validationText, setValidationText] = useState('');
  const [phoneError, setPhoneError] = useState(false);
  const countryName = profile?.country?.toUpperCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, countryName));
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [isInitialZero, setInitialZero] = useState(false);

  const contrySpecificValidation = config?.data?.data?.contrySpecificValidation;
  const isExist = contrySpecificValidation?.findIndex(
    ({ country }) => country === profile?.country
  );

  useEffect(() => {
    const text = config.data?.data?.errorMessages?.VALIDATION['INVALID_PHONE_NO'];
    setValidationText(text);
  }, [config]);

  useEffect(() => {
    if (isLoggedIn && auth.status === 'succeeded') {
      if (profile?.data?.data?.[0]?.profileStep === 0) {
        // TODO: Confirm commenting of the below line
        // dispatch(logout());
      } else {
        navigate(`/${intl.locale}/home`, { replace: true });
      }
    }
  }, [auth.status, dispatch, intl.locale, isLoggedIn, navigate, profile.data.data]);
  // const handleLanguageChange = (lang) => {
  //   context.selectLanguage(lang === 'en' ? 'ar' : 'en');
  // };
  const handleMobileChange = (event) => {
    event.persist();
    let val = event.target.value;
    if (val.length === countryValidations.phnLength && new RegExp('^[0-9]+$').test(val)) {
      if (val.toString()[0] === '0') {
        setInitialZero(true);
      }
      val = val.replace(/^0+/, '');
    }

    if (val?.length == 0 || new RegExp('^[0-9]+$').test(val)) {
      setDisableSubmit(false);
      setPhnNo(val);
    }
  };

  const handleSendOTP = (e) => {
    loginAttemptGA();
    e.preventDefault();
    e.stopPropagation();
    if (phnNo && phnNo.match(countryValidations.phnRegex)) {
      requestOtpMobileGA(countryName, isInitialZero);
      setStatus('loading');
      setDisableSubmit(true);
      dispatch(
        sendOtp({
          cCode: countryValidations?.defaultCCode,
          phnNo,
          sendOtpVia: 'OTP',
          country: countryName,
        })
      )
        .then((resp) => {
          if (resp?.payload?.data?.data?.email) {
            otpResponseMobileGA(countryName, resp.payload.data.data.email ? 'Existing' : 'New');
          }
          setStatus('complete');
          setDisableSubmit(false);
          navigate(`/${context.locale}/verifyOTP`, {
            state: {
              cCode: countryValidations?.defaultCCode,
              phnNo: phnNo,
              component: state?.component,
              retUrl: state?.retUrl,
              oldLocation: state?.oldLocation,
            },
          });
        })
        .catch((error) => {
          setDisableSubmit(false);
          // TODO: Handle send otp error
        });
    } else {
      setDisableSubmit(true);
      setPhoneError(true);
    }
  };

  return (
    <Grid className={css.root}>
      <SeoTitle id="login" />
      <Hreflang page={'login'} />
      <Grid className={css.main}>
        <Grid className={css.mainContainer}>
          <Grid className={css.bannerContainer}>
            {isDesktop ? (
              <img src={context.locale === 'en' ? banner : bannerAr} alt="" />
            ) : (
              <img src={context.locale === 'en' ? bannerSmall : bannerSmallAr} alt="" />
            )}
          </Grid>
          <Paper className={css.loginWrapper}>
            <Grid className={css.loginContainer}>
              <form onSubmit={handleSendOTP} novalidate action="/">
                <LoginForm
                  countryValidations={countryValidations}
                  phnNo={phnNo}
                  handleMobileChange={handleMobileChange}
                  errorText={validationText}
                  phoneError={phoneError}
                />
                <Grid className={css.submit}>
                  <Button
                    disabled={
                      countryValidations?.phnLength !== phnNo.length ||
                      !phnNo.match(countryValidations?.phnRegex) ||
                      !phnNo?.match(countryValidations?.phnRegex) ||
                      disableSubmit
                    }
                    variant="contained"
                    color="primary"
                    type="submit"
                  >
                    <FormattedMessage id="sendOtp" defaultMessage="SEND OTP" />
                  </Button>
                </Grid>
              </form>
            </Grid>
            <SocialMedia />
          </Paper>
        </Grid>
      </Grid>
      {!isDesktop && !contrySpecificValidation[isExist]?.enableSocialLogin && (
        <Grid className={classNames(css.socialMediaContainer, css.stickToBottom)}>
          <Footer />
        </Grid>
      )}
    </Grid>
  );
}

export default Login;
